import { render, staticRenderFns } from "./EntrySheetEducationalResetDialog.vue?vue&type=template&id=26dd6bde"
import script from "./EntrySheetEducationalResetDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntrySheetEducationalResetDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EntrySheetEducationalResetDialog.vue?vue&type=style&index=0&id=26dd6bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports